export const PRODUCT_TYPES = [
  { labelKey: "product", value: 1 },
  { labelKey: "service", value: 2 },
  { labelKey: "downloadable", value: 3 },
];

export const DOWNLOAD_FILE_TYPES = [
  { value: "AUDIO", labelKey: "downloadTypeAudio" },
  { value: "VIDEO", labelKey: "downloadTypeVideo" },
  { value: "IMAGE", labelKey: "downloadTypeImage" },
  { value: "DOCUMENT", labelKey: "downloadTypeDocument" },
];

export const PRODUCT_STATES = [
  { value: "NEW", labelKey: "productStateNew" },
  { value: "USED", labelKey: "productStateUsed" },
];

export const SHIPPING_OPTIONS = [
  { value: 2, apiValue: "FREE", titleKey: "freeShipping", descKey: "freeShippingDesc" },
  { value: 3, apiValue: "PAID", titleKey: "paidShipping", descKey: "paidShippingDesc" },
  { value: 4, apiValue: "PICKUP", titleKey: "localPickup", descKey: "localPickupDesc" },
];

export const MAX_IMAGES = 10;
export const MAX_ATTRIBUTES = 2;
export const MAX_ATTRIBUTE_VALUES = 5;
export const IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const COVER_MAX_BYTES = 3 * 1024 * 1024;
export const DIGITAL_FILE_MAX_BYTES = 100 * 1024 * 1024;

export const mapFreightToShippingOption = (freightOption) => {
  if (freightOption === 1) return "FREESENDCLOUD";
  if (freightOption === 2) return "FREE";
  if (freightOption === 3) return "PAID";
  if (freightOption === 4) return "PICKUP";
  return null;
};

export const mapShippingOptionToFreight = (shippingOption) => {
  if (shippingOption === "FREESENDCLOUD") return 1;
  if (shippingOption === "FREE") return 2;
  if (shippingOption === "PAID") return 3;
  if (shippingOption === "PICKUP") return 4;
  return 0;
};
